var imageBasePath =
  window.location.protocol + "//" + window.location.host + "/";

export const AngleDown = ({ onClick = null, style }) => (
  <i onClick={onClick} style={style} className="fa fa-angle-down" />
);
export const AngleDownMobile = ({ onClick = null }) => (
  <i onClick={onClick} className="fa fa-angle-down" style={{ color: 'black' }} />
);
export const UserIcon = () => <i className="fa fa-user-circle"></i>;
export const LogoutIcon = ({ style }) => (
  <img
    src={imageBasePath + "logout.png"}
    style={style}
    alt={imageBasePath + "logout.png"}
  />
);
export const MobileViewLogo = ({ style }) => (
  <img
    src={imageBasePath + "mobile-logo.png"}
    style={style}
    alt={imageBasePath + "mobile-logo.png"}
  />
);
export const DownIcon = ({ style }) => (
  <img
    src={imageBasePath + "icon-down.png"}
    style={style}
    alt={imageBasePath + "icon-down.png"}
  />
);
export const ClockIcon = ({ style }) => (
  <img
    src={imageBasePath + "clock.png"}
    alt={imageBasePath + "clock.png"}
    style={style}
  />
);
export const MailIcon = () => (
  <img src={imageBasePath + "mail.png"} alt={imageBasePath + "mail.png"} />
);
export const GlobeIcon = () => (
  <img src={imageBasePath + "globe.png"} alt={imageBasePath + "globe.png"} />
);
export const Facebook = ({ onClick }) => (
  <img
    onClick={onClick}
    src={imageBasePath + "facebook.png"}
    alt={imageBasePath + "facebook.png"}
  />
);
export const Instagram = ({ onClick }) => (
  <img
    onClick={onClick}
    src={imageBasePath + "instagram.png"}
    alt={imageBasePath + "instagram.png"}
  />
);
export const Youtube = ({ onClick }) => (
  <img
    onClick={onClick}
    className="youtube"
    src={imageBasePath + "youtube.png"}
    alt={imageBasePath + "youtube.png"}
  />
);
export const Twitter = ({ onClick }) => (
  <img
    onClick={onClick}
    src={imageBasePath + "twitter.png"}
    alt={imageBasePath + "twitter.png"}
  />
);
export const TikTock = ({ onClick }) => (
  <img
    onClick={onClick}
    src={imageBasePath + "tiktok.svg"}
    alt={imageBasePath + "tiktok.svg"}
  />
);
export const Line = () => (
  <img src={imageBasePath + "line.png"} alt={imageBasePath + "line.png"} />
);
export const Viber = () => (
  <img src={imageBasePath + "viber.png"} alt={imageBasePath + "viber.png"} />
);
export const Whatsapp = ({ className }) => (
  <img
    className={className}
    src={imageBasePath + "whatsapp.png"}
    alt={imageBasePath + "whatsapp.png"}
  />
);
export const Gmail = ({ className }) => (
  <img
    className={className}
    src={imageBasePath + "Gmail.png"}
    alt={imageBasePath + "Gmail.png"}
  />
);
export const Whatsappnew = ({ className }) => (
  <img
    className={className}
    src={imageBasePath + "whatsapp-icon2.png"}
    alt={imageBasePath + "whatsapp-icon2.png"}
  />
);
export const SMS = ({ className }) => (
  <img
    className={className}
    src={imageBasePath + "sms.png"}
    alt={imageBasePath + "sms.png"}
  />
);
export const Info = ({ className }) => (
  <img
    className={className}
    src={imageBasePath + "info.png"}
    alt={imageBasePath + "info.png"}
  />
);
export const Favourite = ({ style }) => (
  <img
    style={style}
    src={imageBasePath + "Favourite.png"}
    alt={imageBasePath + "Favourite.png"}
  />
);
export const NotFavourite = ({ style }) => (
  <img
    style={style}
    src={imageBasePath + "NotFavourite.png"}
    alt={imageBasePath + "NotFavourite.png"}
  />
);
export const SearchIcon = () => (
  <img
    src={imageBasePath + "magnified.png"}
    alt={imageBasePath + "magnified.png"}
  />
);
export const CarPic = ({ src, onClickPic }) => (
  <img src={src} onClick={onClickPic} alt={src} />
);
export const StarIcon = ({ onClickAdd }) => (
  <img
    className="star"
    src="star.png"
    onClick={() => onClickAdd()}
    alt="star.png"
  />
);
export const EmptyStarIcon = ({ onClickAdd }) => (
  <img
    className="star"
    src={imageBasePath + "empty-star.png"}
    onClick={() => onClickAdd()}
    alt="empty-star.png"
  />
);
export const GmailMobile = () => (
  <img className="gmail-icon-mobile" src="Gmail.png" />
);
export const Smsmobile = () => (
  <img className="sms-icon-mobile" src="sms.png" />
);
export const Whatsappmobile = () => (
  <img className="sms-icon-mobile" src="whatsapp-icon2.png" />
);
export const Sms = () => <img className="sms-icon" src="sms.png" />;
export const Upload = () => (
  <img className="upload-cloud" src="upload-cloud.png" />
);
export const Upload2 = () => (
  <img className="upload-cloud2" src="upload-cloud.png" />
);
export const Calender = () => <img className="star" src="Icon calendar.png" />;
export const FaStarIcon = () => <i className="fa fa-star" />;
export const OwnerPic = ({ src, onClickTo }) => (
  <img
    className="owner"
    onClick={onClickTo}
    src={imageBasePath + src}
    alt={"src"}
  />
);
export const NotificationIcon = ({ count }) => (
  <div className="notify">
    <span>{count}</span>
    <img src="elipse.png" alt="elipse.png" />
  </div>
);
export const EnvelopeIcon = () => <i className="fa fa-envelope" />;
